import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/Sidebar';

/**
 * AdminLayout — shell para todas las rutas protegidas bajo /admin.
 * Hoy sólo añade Sidebar + main; cuando llegue Stitch se envolverá
 * en un ProtectedRoute que valide la sesión antes de renderizar.
 */
export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-background flex">
      <Sidebar />
      <main className="flex-1 min-w-0 p-8">
        <Outlet />
      </main>
    </div>
  );
}
